







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Devis} from '@/models';

import CrudDevisEdit from '@/components/Crud/Devis/Edit.vue';

@Component({
	components: {
		CrudDevisEdit,
	}
})
export default class CrudDevisEditDialog extends Vue {
	@InOut({ type: Devis  , isVModel: true }) private value!: Devis;
	@InOut({ type: Boolean  , isVModel: false }) private route!: Boolean;

	@Emit()
	private onSubmit(devis: Devis) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		if (this.value.id)
		{
			if (this.route == true) {
				if (
					this.$route.name !== 'devis-show' ||
					this.$route.params["id"] !== this.value.id.toString()
				) {
					this.$router.push({name: 'devis-show', params: { id : this.value.id.toString() }});
				}
			}
		}
		this.value = null;
	}
}
